export const ICONS = {
  PLUS: "#plus",
  MINUS: "#minus",
  CROSS: "#cross",
  TIME: "#time",
  STAR: "#star",
  STARS: "#stars",
  CHEVRON_LEFT: "#chevron-left",
  CHEVRON_RIGHT: "#chevron-right",
  CHEVRON_UP: "#chevron-up",
  CHEVRON_DOWN: "#chevron-down",
  SORT_UP: "#sort-up",
  SORT_DOWN: "#sort-down",
  CHECKMARK: "#checkmark",
  REFRESH: "#refresh",
  FILTER_ADD: "#filter-add",
  FILTER_DEL: "#filter-del",
  SEARCH: "#search",
  DATE: "#date"
};



// WEBPACK FOOTER //
// ./src/icons/Icons.js